import { Component, OnInit, Output, Input, EventEmitter, SimpleChanges } from '@angular/core';
import { ISortType } from 'src/app/shared/models';

@Component({
  selector: 'app-sort-type',
  templateUrl: './sort-type.component.html',
  styleUrls: ['./sort-type.component.less']
})
export class SortTypeComponent implements OnInit {
  @Output() setSortType = new EventEmitter<any>();
  @Input() sortTypeList: ISortType[];
  @Input() sortType: string;
  @Input() page: string;

  default = 'recommended';

  constructor() {
      // if(this.page==='catalog'){
      //   this.default = 'newest_first'
      // }
  }

  ngOnInit() {}

  ngOnChanges(change:SimpleChanges){
    if(change.sortType &&  change.sortType.currentValue){
      this.default = change.sortType.currentValue;
    
    }
    

  }

  sortChanged(event) {
    this.setSortType.emit(event.value);
  }
}
